import { getRetryDelayMs, isRetryableHttpStatus } from '../helpers/retry-fetch.helper';
import { fetchWithTimeout } from '../helpers/utils';
const DEFAULT_MAX_ATTEMPTS = 3;
const DEFAULT_BASE_DELAY_MS = 300;
const DEFAULT_MAX_DELAY_MS = 2000;
const DEFAULT_TIMEOUT_MS = 10000;
const RETRYABLE_STOREFRONT_GRAPHQL_CODES = new Set([
    'THROTTLED',
    'INTERNAL_SERVER_ERROR',
]);
function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
function isRetryableStorefrontHttpStatus(status) {
    return isRetryableHttpStatus(status) || status === 423;
}
function isRetryableStorefrontGraphQLError(errors) {
    return errors.some((error) => RETRYABLE_STOREFRONT_GRAPHQL_CODES.has(error.extensions?.code ?? ''));
}
export async function storefrontApiRequest(query, variables) {
    const url = `https://${window.Shopify.shop}/api/${window.UNTUCKitConfig.shopifyStorefrontApiVersion}/graphql`;
    const requestInit = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': window.UNTUCKitConfig.shopifyStorefrontApiPublicAccessToken,
        },
        body: JSON.stringify({ query, variables }),
    };
    let lastError;
    for (let attempt = 0; attempt < DEFAULT_MAX_ATTEMPTS; attempt++) {
        let response = null;
        try {
            response = await fetchWithTimeout(url, { ...requestInit, timeout: DEFAULT_TIMEOUT_MS });
            if (!response.ok) {
                if (isRetryableStorefrontHttpStatus(response.status) && attempt < DEFAULT_MAX_ATTEMPTS - 1) {
                    await sleep(getRetryDelayMs(response, attempt, DEFAULT_BASE_DELAY_MS, DEFAULT_MAX_DELAY_MS));
                    continue;
                }
                console.error(`Storefront API request failed with status ${response.status}`);
                return null;
            }
            const json = await response.json();
            if (json.errors?.length) {
                if (isRetryableStorefrontGraphQLError(json.errors) && attempt < DEFAULT_MAX_ATTEMPTS - 1) {
                    await sleep(getRetryDelayMs(response, attempt, DEFAULT_BASE_DELAY_MS, DEFAULT_MAX_DELAY_MS));
                    continue;
                }
                console.error('Storefront API GraphQL errors:', json.errors);
                return null;
            }
            return json;
        }
        catch (err) {
            lastError = err;
            if (attempt < DEFAULT_MAX_ATTEMPTS - 1) {
                await sleep(getRetryDelayMs(response, attempt, DEFAULT_BASE_DELAY_MS, DEFAULT_MAX_DELAY_MS));
                continue;
            }
        }
    }
    console.error(lastError);
    return null;
}
